import axios from 'axios';
import * as config from '../config';

export const DASHBOARD_ERROR_REQUEST  = "DASHBOARD_ERROR_REQUEST";
export const DASHBOARD_ERROR_SUCCESS  = "DASHBOARD_ERROR_SUCCESS";
export const DASHBOARD_ERROR_ERROR  = "DASHBOARD_ERROR_ERROR";
export const DASHBOARD_ERROR_CHANGE_COUNT  = "DASHBOARD_ERROR_CHANGE_COUNT";
export const DASHBOARD_ERROR_CHANGE  = "DASHBOARD_ERROR_CHANGE";
export const DASHBOARD_ERROR_FILTERS_RESET  = "DASHBOARD_ERROR_FILTERS_RESET";
export const DASHBOARD_ERROR_FILTERS_CHANGE  = "DASHBOARD_ERROR_FILTERS_CHANGE";
export const DASHBOARD_ERROR_RESET = "DASHBOARD_ERROR_RESET";
export const DASHBOARD_ERROR_RESET_DATA = "DASHBOARD_ERROR_RESET_DATA";

export function Get(companyId,source=2,sortOrder=0,filters,offset,size){
    return (dispatch) =>{
        dispatch({
            type:DASHBOARD_ERROR_REQUEST
        });
        
        axios.post(
            config.apiUrl + "/offers/getbycompany",
            {
                offerName: filters.offerName,
                offerId: filters.offerId,
                companyId: companyId,
                source: source,
                sortOrder: sortOrder,
                showActive: filters.isActive,
                showAvailable: filters.isAvailable,
                periodStart: filters.periodStart,
                periodEnd: filters.periodEnd,
                offset: offset,
                size: size                
            }
        )
        .then((response)=>{
            dispatch({
                type:DASHBOARD_ERROR_SUCCESS,
                payload:response.data.content
            })
        }).catch((error)=>{
            dispatch({
                type:DASHBOARD_ERROR_ERROR
            })
        })
    }
}

export function ChangeCount(count){
    return (dispatch) =>{
        dispatch({
            type:DASHBOARD_ERROR_CHANGE_COUNT,
            payload:count
        })
    }
}

export function Change(field,value){
    return (dispatch) =>{
        dispatch({
            type:DASHBOARD_ERROR_CHANGE,
            payload:{
                field,
                value
            }
        })
    }
}

export function FiltersChange(filters){
    return (dispatch) =>{
        dispatch({
            type:DASHBOARD_ERROR_FILTERS_CHANGE,
            payload:filters
        })
    }
}

export function FiltersReset() {
    return (dispatch) =>{
        dispatch({
            type:DASHBOARD_ERROR_FILTERS_RESET
        })
    }
}


// WEBPACK FOOTER //
// ./src/actions/dashboardErrorActions.js